/**
 * Initialen und Avatar-Farbe aus dem Namen ableiten.
 *
 * Die Demo-Daten trugen beides als eigene Felder mit sich herum. Für echte
 * Kunden wäre das zwei Pflichtangaben mehr im Formular für etwas, das sich
 * vollständig aus dem Namen ergibt — also leiten wir es ab, deterministisch:
 * Derselbe Name bekommt bei jedem Rendern dieselbe Farbe.
 */

/**
 * Die Avatar-Palette — sechs gedeckte, warme Töne aus der CI-Familie
 * (DESIGN.md §2: keine Farben außerhalb der Palette). Alle tragen weiße
 * Initialen mit gutem Kontrast; die alten Prototyp-Farben (Pink, Cyan,
 * Violett) sind seit dem Design-Feinschliff vom 02.09.2026 Geschichte.
 */
const AVATAR_FARBEN = ["#C8962E", "#85382D", "#5F6B3A", "#3F5E7A", "#6B5E4F", "#8C651A"] as const;

/** „Müller Kabeltechnik GmbH" → „MK", „Aldi" → „AL". */
export function initialenVon(name: string): string {
	const woerter = name
		.trim()
		.split(/\s+/)
		.filter((wort) => wort !== "");
	const erstes = woerter[0];

	if (erstes === undefined) {
		return "?";
	}

	const zweites = woerter[1];

	if (zweites !== undefined) {
		return `${erstes.slice(0, 1)}${zweites.slice(0, 1)}`.toUpperCase();
	}

	return erstes.slice(0, 2).toUpperCase();
}

export function farbeFuer(name: string): string {
	let summe = 0;

	for (const zeichen of name) {
		summe = (summe + (zeichen.codePointAt(0) ?? 0)) % AVATAR_FARBEN.length;
	}

	return AVATAR_FARBEN[summe] ?? AVATAR_FARBEN[0];
}
